// Libraries
import React from 'react';
import { useTranslation } from 'react-i18next';

// Enums
import { EngagementReportQuestionType } from 'engagementReport/enums/propTypes';

// Components
import ImageMap from 'engagementReport/components/image/ImageMap';

const ImageReport = ({ question }) => {
  const { t } = useTranslation();
  const { data, imageUrl } = question;
  const isEmpty = data.length === 0;

  return (
    <div className="image-report">
      {isEmpty && (
        <div className="basic-report__subtitle">{t('engagement_report.no_responses')}</div>
      )}
      {!isEmpty && <ImageMap data={data} imageUrl={imageUrl} />}
    </div>
  );
};

ImageReport.propTypes = {
  question: EngagementReportQuestionType.isRequired,
};

export default ImageReport;
